var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionalStep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#DAE4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6694 22.67L24.8894 21.56V18.78M18.2194 13.78L15.9994 14.89L18.2194 13.78ZM15.9994 14.89L13.7794 13.78L15.9994 14.89ZM15.9994 14.89V17.67V14.89ZM24.8894 10.44L22.6694 11.55L24.8894 10.44ZM24.8894 10.44L22.6694 9.33L24.8894 10.44ZM24.8894 10.44V13.22V10.44ZM18.2194 7.11L15.9994 6L13.7794 7.11H18.2194ZM7.10938 10.44L9.32938 9.33L7.10938 10.44ZM7.10938 10.44L9.32938 11.55L7.10938 10.44ZM7.10938 10.44V13.22V10.44ZM15.9994 26L13.7794 24.89L15.9994 26ZM15.9994 26L18.2194 24.89L15.9994 26ZM15.9994 26V23.22V26ZM9.32938 22.67L7.10938 21.56V18.78L9.32938 22.67Z",
    stroke: "#1E2254",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionalStep);
export default __webpack_public_path__ + "static/media/conditional-step.bac041a604918b711278832598c0b48e.svg";
export { ForwardRef as ReactComponent };